import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftOrderPageComponent } from './gift-order-page.component';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../order/components/header/header.module';
import { MainModule } from './components/main/main.module';
import { FooterModule } from './components/footer/footer.module';
import { AsideModule } from '../order/components/aside/aside.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { DialogsModule } from 'app/shared/dialogs/dialogs.module';
import { SectionLeftComponent } from './components/section-left/section-left.component';
import { SectionRightComponent } from './components/section-right/section-right.component';
import { FinalComponent } from './components/final/final.component';
import { SectionFullComponent } from './components/section-full/section-full.component';
import { ButtonModule } from 'app/shared/button/button.module';
import { BlockSnsCardComponent } from './components/block-sns-card/block-sns-card.component';
import { CardModule } from 'app/shared/card/card.module';

@NgModule({
  declarations: [
    GiftOrderPageComponent,
    SectionLeftComponent,
    SectionRightComponent,
    FinalComponent,
    SectionFullComponent,
    BlockSnsCardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    MainModule,
    FooterModule,
    AsideModule,
    AngularSvgIconModule,
    TranslateModule,
    DialogsModule,
    ButtonModule,
    CardModule,
  ],
})
export class GiftOrderPageModule {}
